import React from 'react';
import {NewGameList, NewSlotList} from "./new_game_list";

export default function MainGameNewListLayout(){
    return (
        <div className={"new-game-list-layout"}>
            <NewGameList/>
            <NewSlotList/>
        </div>
    )
}
